// frontend/src/api/serviceOps.js
import { apiClient } from './index';

const serviceOpsApi = {
  // --- PROVIDER MANAGEMENT ---
  createProvider: async (data) => {
    return await apiClient.post('/service-ops/providers', data);
  },

  getAllProviders: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) params.append(key, filters[key]);
    });
    return await apiClient.get(`/service-ops/providers?${params.toString()}`);
  },

  deleteProvider: async (providerId) => {
    return await apiClient.delete(`/service-ops/providers/${providerId}`);
  },

  updateProviderStatus: async (providerId, action) => {
    return await apiClient.post(`/service-ops/providers/${providerId}/status`, { action });
  },

  // --- APPLICATION WORKFLOW ---
  submitApplication: async (data) => {
    return await apiClient.post('/service-ops/apply', data);
  },

  getMyApplications: async () => {
    return await apiClient.get('/service-ops/my-applications');
  },

  getApplications: async (status = null) => {
    const url = status ? `/service-ops/applications?status=${status}` : '/service-ops/applications';
    return await apiClient.get(url);
  },

  reviewApplication: async (appId, action, reason = null) => {
    return await apiClient.post(`/service-ops/applications/${appId}/review`, { action, reason });
  },

  // --- VERIFICATION & AGREEMENT ---
  verifyAddress: async (data) => {
      return await apiClient.post('/service-ops/verify-address', data);
  },

  getPartnerAgreement: async () => {
      return await apiClient.get('/service-ops/agreement');
  },

  // --- BOOKING OPERATIONS ---
  
  // 1. Create Quote (Provider)
  createQuote: async (bookingId, data) => {
    return await apiClient.post(`/service-ops/bookings/${bookingId}/create-quote`, data);
  },

  // 2. Respond to Quote (Customer)
  respondToQuote: async (quoteId, action, reason = null) => {
    return await apiClient.post(`/service-ops/quotes/${quoteId}/respond`, { action, reason });
  },

  // 3. Get Quote Details
  getQuote: async (quoteId) => {
    return await apiClient.get(`/service-ops/quotes/${quoteId}`);
  },

  // 4. Generate Final Invoice (Provider)
  generateInvoice: async (bookingId, data) => {
    return await apiClient.post(`/service-ops/bookings/${bookingId}/invoice`, data);
  },

  assignProvider: async (bookingId, providerId) => {
    return await apiClient.post(`/service-ops/bookings/${bookingId}/assign`, { provider_id: providerId });
  },

  // --- PROVIDER PORTAL ---
  getProviderJobs: async () => {
    return await apiClient.get('/service-ops/provider/jobs');
  },

  completeJob: async (bookingId, data) => {
    return await apiClient.post(`/service-ops/bookings/${bookingId}/complete`, data);
  },

  // --- RECORDS / RECEIPTS ---
  getServiceRecord: async (recordId) => {
    return await apiClient.get(`/service-ops/records/${recordId}`);
  }
};

export { serviceOpsApi };